import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="math-formula"
export default class extends Controller {
  static targets = ["content"]

  // Demo:
  // https://github.com/mathjax/MathJax-demos-web?tab=readme-ov-file

  connect() {
    if(MathJax && MathJax.texReset) {
      this.renderMath()
    }
  }

  renderMath() {
    MathJax.texReset();

    var options = MathJax.getMetricsFor(this.element);
    options.display = false;

    // <span data-math-style="inline">x = {-b \pm \sqrt{b^2-4ac} \over 2a}</span>
    document.querySelectorAll("[data-math-style]").forEach(element => {
      MathJax.tex2svgPromise(element.innerText, options).then(function (node) {
        element.innerText = ""
        element.appendChild(node);
      });
    });
  }

  contentTargetConnected(target) {
    var options = MathJax.getMetricsFor(this.element);
    options.display = false;

    MathJax.tex2svgPromise(target.dataset.value, options).then(function (node) {
      target.appendChild(node);
    });
  }

  disconnect() {
    if(MathJax && MathJax.startup) {
      MathJax.startup.document.clear();
    }
  }
}
